import { AppRouteProps } from '@bsm/component'
import React from 'react'

const UserOrganisationDetailsAbout = React.lazy(
    () => import("./about/containers/UserOrganisationDetailsAbout")
);
const UserOrganisationDetailsParameters = React.lazy(
    () => import("./parameters/containers/UserOrganisationDetailsParameters")
);
const UserOrganisationGroupsList = React.lazy(
    () => import("./groups/containers/UserOrganisationGroupsList")
);
const UserOrganisationInvitationList = React.lazy(
    () => import("./users/containers/UserOrganisationInvitationList")
);

export const UserOrganisationViewRoutes: Array<AppRouteProps> = [
    {
        path: "about",
        title: "std_about",
        element: <UserOrganisationDetailsAbout />,
    },
    {
        path: "groups",
        title: "Generic.UserOrganisation.Groups.title",
        element: <UserOrganisationGroupsList />,
    },
    {
        path: "users",
        title: "Generic.UserOrganisation.Users.title",
        element: <UserOrganisationInvitationList />,
    },
    {
        path: "parameters",
        title: "std_params",
        element: <UserOrganisationDetailsParameters />,
    },
];
